import {
  addOperationLayer_actionType,
  incrementMapReloadCount_actionType,
  setErrorLayers_actionType,
  setMapView_actionType,
  setMapViewerRole_actionType,
  setOperationLayers_actionType,
  setRejectedLayers_actionType,
  setShowModules_actionType,
  updateOperationLayer_actionType,
} from "../constants";

const initialState = {
  view: null,
  mapReloadCount: 0,
  op: [],
  errorLayers: [],
  operationLayers: [],
  rejectedLayers: [],
  role: null,
  showModules: true,
};

export const LAYER_STATES = {
  LOADING: "loading",
  LOADED: "loaded",
  ERROR: "error",
};

const mapViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case setMapView_actionType: {
      const { payload } = action;
      return {
        ...state,
        view: payload,
      };
    }
    case setOperationLayers_actionType: {
      const { payload } = action;
      return {
        ...state,
        operationLayers: payload,
      };
    }
    case setRejectedLayers_actionType: {
      const { payload } = action;
      return {
        ...state,
        rejectedLayers: payload,
      };
    }
    case setErrorLayers_actionType: {
      const { payload } = action;

      return {
        ...state,
        errorLayers: payload,
      };
    }
    case updateOperationLayer_actionType: {
      const { id, alias, values } = action.payload;
      // let updatedOperationLayers = [...state.operationLayers];

      const updatedOperationLayers = state.operationLayers.map((layer) =>
        layer.id === id ? { ...layer, ...values } : layer
      );

      return {
        ...state,
        operationLayers: updatedOperationLayers,
      };
    }
    case addOperationLayer_actionType: {
      const { payload } = action;

      return {
        ...state,
        operationLayers: [...state.operationLayers, payload],
      };
    }
    case incrementMapReloadCount_actionType: {
      return {
        ...state,
        mapReloadCount: state.mapReloadCount + 1,
      };
    }
    case setMapViewerRole_actionType: {
      const { payload } = action;
      return {
        ...state,
        role: payload,
      };
    }
    case setShowModules_actionType: {
      const { payload } = action;
      return {
        ...state,
        showModules: payload,
      };
    }
  }

  return state;
};

export default mapViewReducer;
